module.exports = __webpack_public_path__ + "img/payment-discount-bg.f39322c6.svg";